import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportSummaryStockPageRoutingModule } from './report-summary-stock-routing.module';

import { ReportSummaryStockPage } from './report-summary-stock.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportSummaryStockPageRoutingModule
  ],
  declarations: [ReportSummaryStockPage]
})
export class ReportSummaryStockPageModule {}
